import data from "../../../../../src/ToggleSwitch.docs.json";
import * as React from 'react';
export default {
  data,
  React
};